import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/goals/$goalId')({

}).lazy(() => import('./$goalId.lazy').then((d) => d.Route));
